/* Version: 3.5.149 */
'use client';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useCallback } from 'react';
import { uniqueId } from '../utils/functions.js';

function createQueueItem(value) {
  // a unique key for each value so callees know when they need to update
  // necessary when two contiguous values are identical, but something still needs to happen when the first is popped
  return {
    key: uniqueId(),
    value: value
  };
}
function mapQueueItems(values) {
  return values.map(createQueueItem);
}
function useQueue() {
  var _queue$, _queue$2;
  var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _useState = useState(mapQueueItems(initial)),
    _useState2 = _slicedToArray(_useState, 2),
    queue = _useState2[0],
    setQueue = _useState2[1];

  // memoized to avoid referential inequality when using these functions as hook dependencies
  var push = useCallback(function (value) {
    return setQueue(function (oldQueue) {
      return oldQueue.concat(createQueueItem(value));
    });
  }, []);
  var pop = useCallback(function () {
    return setQueue(function (oldQueue) {
      return oldQueue.slice(1);
    });
  }, []);
  var concat = useCallback(function (values) {
    return setQueue(function (oldQueue) {
      return oldQueue.concat(mapQueueItems(values));
    });
  }, []);
  var clear = useCallback(function () {
    return setQueue([]);
  }, []);
  return {
    head: (_queue$ = queue[0]) === null || _queue$ === undefined ? undefined : _queue$.value,
    key: (_queue$2 = queue[0]) === null || _queue$2 === undefined ? undefined : _queue$2.key,
    queue: queue.map(function (_ref) {
      var value = _ref.value;
      return value;
    }),
    push: push,
    pop: pop,
    concat: concat,
    clear: clear
  };
}

export { useQueue as default };
